import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './App.scss'
import SplashPage from './components/SplashPage'
import About from './pages/About'
import Itinerary from './pages/Itinerary'
import History from './pages/History'

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<SplashPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/history" element={<History />} />
          <Route path="/itinerary" element={<Itinerary />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App